<template>
  <div class="w-full h-full flex items-center gap-2.5 min-w-0">
    <!-- Bar Visualizer -->
    <div class="flex-grow relative h-1 rounded-lg bg-neutral-50" :style="{ maxWidth: `${maxBarWidth}px` }">
      <div class="absolute left-0 top-0 bottom-0 rounded-lg" :class="barRenderColor" :style="{ width: barRenderWidth }"
      style="min-width: 4px" />
    </div>
    <!-- Value -->
    <BaseText size="sm" :type="Math.round(value) && !useLabelWeight ? 'body' : 'label'" class="text-text-muted"
    style="width: 24px">
      {{ Math.round(value) || '--' }}
    </BaseText>
  </div>
</template>

<script>
export default {
  name: 'PercentileMetricScale',
  props: {
    value: {
      type: Number,
      default: 0
    },
    maxBarWidth: {
      type: Number,
      default: 116
    },
    useLabelWeight: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    barRenderWidth () {
      return `${Math.min(Math.round(this.value), 100)}%`
    },
    barRenderColor () {
      if (this.value >= 75) return 'bg-secondary-green-200'
      else if (this.value >= 50) return 'bg-secondary-yellow-200'
      else if (this.value > 0) return 'bg-secondary-red-200'
      else return 'bg-text-muted'
    }
  }
}
</script>